import React from 'react';
import 'setimmediate';
import flatten from 'lodash/flatten';
import {render} from 'react-dom';
import {ThemeProvider} from '@components/@theme';
import {appRoutes} from 'components/routes/Router';

import * as dayjs from 'dayjs';
import * as duration from 'dayjs/plugin/duration';

// TODO remove these once old MUI is gone.
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import MenuItem from 'material-ui/MenuItem';

/** Global prototype initialization for older browsers and IE */
if (typeof String.prototype.endsWith !== 'function') {
  // eslint-disable-next-line
  String.prototype.endsWith = function (suffix) {
    return this.indexOf(suffix, this.length - suffix.length) !== -1;
  };
}

if (typeof String.prototype.trim !== 'function') {
  // eslint-disable-next-line
  String.prototype.trim = function () {
    return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
  };
}

// @ts-ignore
if (typeof Array.prototype.flatten !== 'function') {
  // @ts-ignore
  // eslint-disable-next-line
  Array.prototype.flatten = function () {
    console.warn(
      'Array.prototype.flatten not supported by browsers natively. Please, use lodash/flatten instead or https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/flat'
    );
    return typeof this.flat === 'function' ? this.flat() : flatten(this);
  };
}

// Install duration plugin.
dayjs.extend(duration);

// When we're ready, add "import * as calendar from 'dayjs/plugin/calendar';" above.

// Install calendar plugin (used in formatDateTimeHuman).
// dayjs.extend(calendar);

// TODO remove this once old MUI is gone.
// Disable ripple effect for material UI components
const rippleComponents = [FlatButton, RaisedButton, IconButton, MenuItem];
rippleComponents.forEach(component => {
  component.defaultProps.disableTouchRipple = true;
  component.defaultProps.disableFocusRipple = true;
});

// Render the main component into the dom
render(<ThemeProvider>{appRoutes}</ThemeProvider>, document.getElementById('app'));
